module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"enter-query":"Введите ключевое слово не менее 3-х символов"},"en":{"enter-query":"Enter a keyword of at least 3 characters"}}')
  delete Component.options._Ctor
}
